import { render, staticRenderFns } from "./Virtualnursing.vue?vue&type=template&id=605caa47&scoped=true"
import script from "./Virtualnursing.vue?vue&type=script&lang=js"
export * from "./Virtualnursing.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Virtualnursing.vue?vue&type=style&index=1&id=605caa47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605caa47",
  null
  
)

export default component.exports